import { BrandComponent, Disclaimer, Div, Pill } from '@vgrubs/components';
import { Brand } from 'components/src/types/brand.types';
import { useNavigate } from 'react-router-dom';
import { BrandPausedTimePill } from './BrandPausedTImes';
import { PushOrdersToPosPill } from './PushOrdersToPosPill';

export const BrandLocationComponent = ({
  brand,
  isPos,
}: {
  brand: Brand;
  isPos: boolean;
}) => {
  const navigate = useNavigate();

  const hasAnyPill = !!brand?.paused || (isPos && !!brand?.pushOrdersToPos);

  return (
    <BrandComponent
      brand={brand}
      onClick={() => navigate(`/brand/${brand.id}`)}
      showType
    >
      <Div $flex $center $gap="8px" $wrap $mt="12">
        <BrandPausedTimePill pausedTime={brand?.paused} />

        <PushOrdersToPosPill
          pushOrdersToPos={brand?.pushOrdersToPos}
          isPos={isPos}
        />

        {!hasAnyPill && (
          <Pill $background={'none'}>
            <Disclaimer $m="0">-</Disclaimer>
          </Pill>
        )}
      </Div>
    </BrandComponent>
  );
};
